import type { ProductInformation } from '@dealerportal/common';
import type { ComponentType } from 'react';
import { useLoadKBFrComponent } from '../../Hooks/useLoadKBFrComponent';
import { useKBFrItemContext } from './kbfrItemContext';

const CONTENT_BASE_URL = 'https://testcomponents-v1-deve.cyncly-content.net/';

type Props = {
  product: ProductInformation;
};

/**
 * Renders the Cyncly `SelectionViewer` (3D visualizer) for a product. Builds
 * its own item context and listens for `item-context-list-update` messages, so
 * it can be rendered on its own or alongside `KBFrConfigurator`.
 */
export const KBFrVisualizer = ({ product }: Props) => {
  const context = useKBFrItemContext(product);
  const SelectionViewer =
    useLoadKBFrComponent<ComponentType<any>>('SelectionViewer');

  if (!context || !SelectionViewer) return null;

  return (
    <div className="viewer-3d-container ui-relative ui-h-[518px]">
      <SelectionViewer itemContextList={[context]} baseUrl={CONTENT_BASE_URL} />
    </div>
  );
};
